/**
 * @generated SignedSource<<c90ee0b975e43b949a1672600a5245cc>>
 * @relayHash 838f6c4fb52c2aef06e7177fbaac9aa1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 58bd8572e1346ce73b12b8a3d3da2d4bfa71ad3331d216c6673184377ed3f881

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IncidentsPageWrapperQuery } from './IncidentsPageWrapperQuery.graphql';

const node: PreloadableConcreteRequest<IncidentsPageWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "58bd8572e1346ce73b12b8a3d3da2d4bfa71ad3331d216c6673184377ed3f881",
    "metadata": {
      "connection": [
        {
          "count": "servicePageSize",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "linkedOperationsComponentsByProject"
          ]
        }
      ]
    },
    "name": "IncidentsPageWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
